import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { firestore, database } from 'firebase';
import { DatabaseService } from '../database.service';
import * as mapboxgel from 'mapbox-gl';
import { environment } from '../../environments/environment'
import { GeoJson } from '../map';
import { LatestData } from '../newdata';

@Component({
  selector: 'app-newcase',
  templateUrl: './newcase.component.html',
  styleUrls: ['./newcase.component.css']
})
export class NewcaseComponent implements OnInit {

  newcase = new FormGroup({
    fullname: new FormControl('', [Validators.required]),
    sex: new FormControl('1', [Validators.required]),
    age: new FormControl('', [Validators.required]),
    phone: new FormControl('', [Validators.required]),
    lng: new FormControl('', [Validators.required]),
    lat: new FormControl('', [Validators.required]),
    region: new FormControl('', [Validators.required]),
    date: new FormControl('', [Validators.required]),
    
  })

  map: mapboxgel.Map;
  requestSent: boolean = false;
  errorMessage = "";
  isLoading: boolean = false;
  successMessage = "";

  source: any;

  constructor(private db: DatabaseService) {
    mapboxgel.accessToken = "pk.eyJ1IjoiY2hvdXJhYml0YWhlciIsImEiOiJjazR0MWllOWwxNXd4M25wNHI0aWJ6azNuIn0.Q765LjZgTSfrKLUB3exqDw";

    try {
      mapboxgel.setRTLTextPlugin(
        'https://api.mapbox.com/mapbox-gl-js/plugins/mapbox-gl-rtl-text/v0.2.3/mapbox-gl-rtl-text.js',
        null,
        true);
    } catch (error) {

    }

  }

  ngOnInit(): void {
    this.initMap();
  }

  initMap() {
    this.buildMap();


  }


  buildMap() {
    this.map = new mapboxgel.Map({
      container: 'map',
      style: 'mapbox://styles/mapbox/streets-v11',
      zoom: 5,
      center: [9.530273341475947, 34.31351410215606]
    });



    this.map.addControl(new mapboxgel.NavigationControl());


    this.map.on('click', (event) => {
      console.log(event);

      this.newcase.setValue({
        fullname: this.newcase.value.fullname,
        sex: this.newcase.value.sex,
        age: this.newcase.value.age,
        phone: this.newcase.value.phone,
        lng: event.lngLat.lng,
        lat: event.lngLat.lat,
        region: this.newcase.value.region,
        date: this.newcase.value.date,
        
      });

      this.source.setData(new GeoJson([event.lngLat.lng,event.lngLat.lat],{
        "color": "#dc3545",
        "description": "<div><strong>CAS CONFIRMÉ</strong></div>"
      }));



    })

    this.map.on('load', () => {
      this.map.addSource('newinfection', {
        'type': 'geojson',
        'data': {
          'type': 'FeatureCollection',
          'features': [
            new GeoJson([9.530273341475947, 34.31351410215606],{
              "color": "#dc3545",
              "description": "<div><strong>CAS CONFIRMÉ</strong></div>"
            })
          ]
        }
      });

      this.map.addLayer({
        'id': 'newinfection',
        'type': 'circle',
        'source': 'newinfection',
        'paint': {

          'circle-radius': {
            'base': 50.75,
            'stops': [[40, 10], [60, 460]]
          },
          'circle-color': ['get', 'color']
        }
      });

      this.source = this.map.getSource('newinfection');



    });



  }

  sendDeclaration(e) {
    this.isLoading = true;
    var requestdata = {};
    try {
      requestdata = {
        userinformations: {
          fullname: this.newcase.value.fullname,
          sex: this.newcase.value.sex,
          age: this.newcase.value.age,
          phone: this.newcase.value.phone,
          region: this.newcase.value.region,
          s1: true,
          s2: true,
          s3: true,
          s4: true,
          s5: true,
          s6: true,
          s7: true,

        },
        position: new firestore.GeoPoint(parseFloat(this.newcase.value.lat), parseFloat(this.newcase.value.lng)),
        stat: 2,
        addDate: new Date(this.newcase.value.date)
      };

      this.db.addNewInfection(requestdata).then((data) => {
        if (data.id) {
          this.successMessage = "Infection ajoutée avec succès.";
          this.requestSent = true;
          this.isLoading = false;
          this.newcase.reset();
        } else {
          this.errorMessage = "Une erreur s'est produite lors de l'envoi de votre demande, nous essayons à nouveau.";
          this.isLoading = false;
        }

      }).catch((error) => {
        this.errorMessage = "Une erreur s'est produite lors de l'envoi de votre demande, nous essayons à nouveau.";
        this.isLoading = false;
      });
    } catch (error) {
      this.errorMessage = "Une erreur s'est produite lors de l'envoi de votre demande, nous essayons à nouveau.";
      this.isLoading = false;
    }




  }

}
